import { DashboardView, GuardState } from "./enums";

export const APP_VERSION = "3.0.4";
export const ACCOUNT_GRACE_PERIOD_DAYS = 15;
export const LAST_UPDATE_TC = new Date(2024, 2, 1);
export const LAST_UPDATE_PC = new Date(2024, 2, 1);
export const HOME_CARDS = [
  { id: 1, delay: 0.5, icon: 'FaCode' },
  { id: 2, delay: 0.7, icon: 'FaGamepad' },
  { id: 3, delay: 1, icon: 'FaRocket' },
  { id: 4, delay: 1.2, icon: 'FaPalette' },
  { id: 5, delay: 1.4, icon: 'FaLink' },
  { id: 6, delay: 1.6, icon: 'FaSyncAlt' },
];
export const PLAN_CARDS = [
  { id: "basic", cta_url: "/signup", highlight: true, delay: 0.5 },
  { id: "pro", highlight: false, delay: 0.7 },
];
export const ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
export const DASHBOARD_TITLE = {
  [DashboardView.DASHBOARD]: 'dashboard.nav.dashboard',
  [DashboardView.PROFILE]: 'dashboard.nav.profile',
  [DashboardView.LINKS]: 'dashboard.nav.links',
  [DashboardView.APPEARANCE]: 'dashboard.nav.appearance',
  [DashboardView.PREVIEW]: 'dashboard.nav.preview',
  [DashboardView.SETTINGS]: 'dashboard.nav.settings'
};
export const DRAWER_WIDTH = 240;
export const BRAND_LEFT = 'rgba(58, 97, 134, 1)';
export const BRAND_RIGHT = 'rgba(137, 37, 62, 1)';
// Linkerto dark (theme background.default) — browser chrome fallback for
// gradient profiles, since <meta name="theme-color"> can't hold a gradient.
export const BRAND_DARK = '#0f1c29';
export const BRAND_DARK_2 = '#05070a';

export const PROFILE_TITLE_MAX = 50;
export const PROFILE_DESC_MAX = 200;
export const PROFILE_TITLE_COUNTER_THRESHOLD = 40;
export const PROFILE_DESC_COUNTER_THRESHOLD = 160;

export const GUARD_STATE_COLOR: Record<GuardState, string> = {
  [GuardState.IDLE]: 'currentColor',
  [GuardState.VALID]: 'var(--success-color)',
  [GuardState.WARNING]: 'var(--warning-color)',
  [GuardState.ERROR]: 'var(--error-color)',
};

export const SWIPE_DELETE_WIDTH = 80;
export const SWIPE_GAP = 8;
export const SWIPE_OPEN_THRESHOLD = 32;
export const SWIPE_VELOCITY_THRESHOLD = 300;

export const QR_CONTRAST_MIN_RATIO = 3.0;
export const QR_FALLBACK_BG = '#ffffff';
export const QR_FALLBACK_FG = '#000000';

// Response codes for GET /profile/get-profile/:username
export const PROFILE_STATUS_OK = 1;
export const PROFILE_STATUS_NOT_FOUND = -2;
export const HTTP_NOT_FOUND = 404;


export const CHART_SKELETON_COLOR = 'rgba(255, 255, 255, 0.13)';
export const CHART_SKELETON_POINTS = [
  { x: 28,  y: 149 },
  { x: 108, y: 129 },
  { x: 188, y: 139 },
  { x: 268, y: 106 },
  { x: 348, y: 119 },
  { x: 428, y: 93  },
  { x: 512, y: 103 },
];

export const TYPE_COLORS = {
  feature:     '#4caf50',
  improvement: '#2196f3',
  fix:         '#ff9800',
  security:    '#9c27b0',
};

export const THEME_PRESETS = [
  {
    id: 'neon-night',
    labelKey: 'profile.theme.presets.neon-night',
    theme: {
      text: { primary: 'rgba(0, 255, 150, 1)', secondary: 'rgba(180, 180, 200, 1)' },
      button: {
        text: 'rgba(0, 255, 150, 1)',
        background: 'rgba(0, 0, 0, 0.3)',
        border: { color: 'rgba(0, 255, 150, 0.7)', width: '1px', radius: '4px' },
        shadow: { enabled: true, color: 'rgba(0, 255, 150, 0.25)' },
      },
      background: {
        type: 'gradient',
        solid: 'rgba(5, 5, 15, 1)',
        gradient: { left: 'rgba(5, 5, 15, 1)', right: 'rgba(10, 2, 28, 1)', direction: '135deg' },
      },
    },
  },
  {
    id: 'sunset',
    labelKey: 'profile.theme.presets.sunset',
    theme: {
      text: { primary: 'rgba(255, 255, 255, 1)', secondary: 'rgba(255, 210, 190, 1)' },
      button: {
        text: 'rgba(255, 255, 255, 1)',
        background: 'rgba(255, 255, 255, 0.12)',
        border: { color: 'rgba(255, 255, 255, 0.5)', width: '1px', radius: '50px' },
        shadow: { enabled: false, color: 'rgba(255, 100, 50, 0.3)' },
      },
      background: {
        type: 'gradient',
        solid: 'rgba(255, 94, 58, 1)',
        gradient: { left: 'rgba(255, 94, 58, 1)', right: 'rgba(200, 25, 90, 1)', direction: '135deg' },
      },
    },
  },
  {
    id: 'minimal',
    labelKey: 'profile.theme.presets.minimal',
    theme: {
      text: { primary: 'rgba(20, 20, 20, 1)', secondary: 'rgba(100, 100, 100, 1)' },
      button: {
        text: 'rgba(20, 20, 20, 1)',
        background: 'rgba(255, 255, 255, 1)',
        border: { color: 'rgba(210, 210, 210, 1)', width: '1px', radius: '8px' },
        shadow: { enabled: false, color: 'rgba(0, 0, 0, 0.08)' },
      },
      background: {
        type: 'solid',
        solid: 'rgba(248, 248, 248, 1)',
        gradient: { left: 'rgba(248, 248, 248, 1)', right: 'rgba(225, 225, 225, 1)', direction: '135deg' },
      },
    },
  },
  {
    id: 'ocean',
    labelKey: 'profile.theme.presets.ocean',
    theme: {
      text: { primary: 'rgba(110, 210, 255, 1)', secondary: 'rgba(160, 200, 220, 1)' },
      button: {
        text: 'rgba(255, 255, 255, 1)',
        background: 'rgba(0, 90, 140, 0.35)',
        border: { color: 'rgba(110, 210, 255, 0.6)', width: '1px', radius: '12px' },
        shadow: { enabled: true, color: 'rgba(0, 140, 200, 0.25)' },
      },
      background: {
        type: 'gradient',
        solid: 'rgba(8, 28, 70, 1)',
        gradient: { left: 'rgba(8, 28, 70, 1)', right: 'rgba(0, 65, 95, 1)', direction: '180deg' },
      },
    },
  },
];

export const BORDER_WIDTH_OPTIONS = [
  { id: 1, label: '0px' },
  { id: 2, label: '1px' },
  { id: 3, label: '2px' },
  { id: 4, label: '3px' },
  { id: 5, label: '4px' },
  { id: 6, label: '5px' },
];

export const BORDER_RADIUS_OPTIONS = [
  { id: 1, label: '0px' },
  { id: 2, label: '4px' },
  { id: 3, label: '8px' },
  { id: 4, label: '12px' },
  { id: 5, label: '16px' },
  { id: 6, label: '50px' },
];

export const GRADIENT_DIRECTIONS = [
  { value: '90deg'  },
  { value: '135deg' },
  { value: '180deg' },
  { value: '225deg' },
  { value: '0deg'   },
];

export const THEME_DEFAULT_COLOR = 'rgba(255, 255, 255, 1)';

export const THEME_CUSTOM_BG = `linear-gradient(135deg, ${BRAND_LEFT}, ${BRAND_RIGHT})`;

export const PUBLIC_PROFILE_BASE = 'linkerto.me';

export const SHARE_NETWORKS = [
  { id: 'whatsapp', color: '#25D366' },
  { id: 'twitter',  color: '#212121' },
  { id: 'telegram', color: '#2AABEE' },
  { id: 'facebook', color: '#1877F2' },
  { id: 'linkedin', color: '#0A66C2' },
  { id: 'reddit',   color: '#FF4500' },
  { id: 'email',    color: '#555E6D' },
];

export const SETTINGS_UPGRADE_FEATURES = [
  'settings.billing.upgrade-item-1',
  'settings.billing.upgrade-item-2',
  'settings.billing.upgrade-item-3',
];

export const THEME_FORM_INITIAL = {
  textPrimary:    THEME_DEFAULT_COLOR,
  textSecondary:  THEME_DEFAULT_COLOR,
  btnText:        THEME_DEFAULT_COLOR,
  btnBg:          THEME_DEFAULT_COLOR,
  btnBorderColor: THEME_DEFAULT_COLOR,
  btnShadowColor: 'rgba(0, 0, 0, 0.2)',
  bgSolid:        THEME_DEFAULT_COLOR,
  bgLeft:         THEME_DEFAULT_COLOR,
  bgRight:        THEME_DEFAULT_COLOR,
  borderWidth:    null,
  borderRadius:   BORDER_RADIUS_OPTIONS[5],
  shadowEnabled:  false,
  bgType:         'gradient',
  gradientDir:    '90deg',
};
